const rejectedWithValueErrorHandler = (userId: string | null, deviceId: string | null, message: string) => ({ userId, deviceId, message });

export default rejectedWithValueErrorHandler;
